import { CHART_PLUGINS } from 'sharedComponents/Chart/constants';
import colors from 'theme/_colors.scss';

export const chartPlugins = [
    CHART_PLUGINS.NO_DATA_TO_DISPLAY,
    CHART_PLUGINS.HIGHCHARTS_MORE,
    CHART_PLUGINS.BOOST,
    CHART_PLUGINS.EXPORTING,
    CHART_PLUGINS.OFFLINE_EXPORTING,
    CHART_PLUGINS.STOCK // for Navigator (Timeline Zoom)
];

export const CHART_CONDITION_TREND_KPI_TYPE = 'Kpi';

export const defaultOverallVibrationSignal = 'Anomaly_OverallVibration';

export const statusBarColors = {
    Poor: colors.pomegranate,
    Tolerable: colors.orangePeel,
    Good: colors.jungleGreen,
    Unknown: colors.neutralGray
};
export const maxAnomalyLevel = 5;


export const RETRAINING_STATUS = {
    TRAINING: 'training',
    COMPLETED: 'completed'
};

export const speedKPI = 'Speed';

export const Alignment = {
    LEFT: 'left',
    CENTER: 'center',
    RIGHT: 'right'
};
